import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav style={styles.navbar} className="container-fluid">
      <div className="row align-items-center">
        <div className="col-1"></div> {/* Left Space */}

        <div className="col-10" style={styles.innerContainer}>
          {/* Left Logo */}
          <div style={styles.left}>
          <a href="/">
  <img
    src="/ShubhPaisa.svg"
    alt="ShubhPaisa Logo"
    style={isMobile ? styles.logoMobile : styles.logoDesktop}
  />
</a>

          </div>

          {/* Hamburger Menu (Mobile) */}
          {isMobile && (
            <div style={styles.hamburger} onClick={toggleMenu}>
              <div style={styles.bar}></div>
              <div style={styles.bar}></div>
              <div style={styles.bar}></div>
            </div>
          )}

          {/* Nav Links */}
          <ul
            style={{
              ...styles.navLinks,
              ...(isMobile
                ? {
                    flexDirection: "column",
                    position: "absolute",
                    top: "70px",
                    left: 0,
                    width: "100%",
                    background: "#f0f4ff",
                    display: menuOpen ? "flex" : "none",
                    padding: "10px 0",
                    borderTop: "1px solid #ddd",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }
                : {}),
            }}
          >
            {[
              { name: "Home", path: "/" },
              // { name: "Service", path: "/service" },
              { name: "Career", path: "/careers" },
              { name: "Blog", path: "/blogs" },
              // { name: "Policy", path: "/policy" },
              { name: "About us", path: "/about-us" },
            ].map((item) => (
              <li key={item.name} style={styles.navItem}>
                <NavLink
                  to={item.path}
                  style={({ isActive }) => ({
                    textDecoration: "none",
                    color: isActive ? "#1e50a2" : "#000",
                    fontWeight: isActive ? "bold" : "normal",
                  })}
                  onClick={() => {
                    if (isMobile) setMenuOpen(false);
                    window.location.href = item.path;
                  }}
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {!isMobile && (
  <button
    style={styles.loginBtn}
    onClick={() => navigate("/login")}
  >
    Login
  </button>
)}   </div>

        <div className="col-1"></div> {/* Right Space */}
      </div>
    </nav>
  );
}

const styles = {
  navbar: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    width: "100%",
    background: "#f0f4ff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    padding: "14px 0",
  },
  innerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
  logoDesktop: {
    width: "180px",
  },
  logoMobile: {
    width: "140px",
  },
  navLinks: {
    listStyle: "none",
    display: "flex",
    gap: "30px",
    margin: 0,
    alignItems: "center",
    transition: "all 0.3s ease",
  },
  navItem: {
    cursor: "pointer",
    fontSize: "16px",
  },
  loginBtn: {
    background: "#fff",
    border: "1px solid #ccc",
    borderRadius: "20px",
    padding: "8px 20px",
    cursor: "pointer",
    fontWeight: "500",
  },
  hamburger: {
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    padding: "5px",
  },
  bar: {
    width: "25px",
    height: "3px",
    backgroundColor: "#333",
    margin: "4px 0",
    borderRadius: "2px",
  },
};
